export const SETLIST_LABELS = {
  titlePlaceholder: 'Song title',
  detailPlaceholder: 'BPM 120, 3:45, person, note…',
  secondFieldPlaceholder: 'Second value',
  untitledItem: 'Untitled song',
  itemFallback: 'Song',
  addItem: 'Add song',
  addItemA11y: 'Add song',
  moveUpA11y: 'Move item up',
  moveDownA11y: 'Move item down',
  collapseA11y: 'Collapse details',
  expandA11y: 'Expand details',
  removeItemA11y: 'Remove item',
};

export const GUEST_LIST_LABELS = {
  titlePlaceholder: 'Guest name',
  detailPlaceholder: 'Plus-one, role, ticket type…',
  secondFieldPlaceholder: 'Second value',
  untitledItem: 'Untitled guest',
  itemFallback: 'Guest',
  addItem: 'Add guest',
  addItemA11y: 'Add guest',
  moveUpA11y: 'Move guest up',
  moveDownA11y: 'Move guest down',
  collapseA11y: 'Collapse guest details',
  expandA11y: 'Expand guest details',
  removeItemA11y: 'Remove guest',
};

export const CONTACTS_LABELS = {
  titlePlaceholder: 'Name or role',
  detailPlaceholder: 'Phone, email, venue…',
  secondFieldPlaceholder: 'Second value',
  untitledItem: 'Untitled contact',
  itemFallback: 'Contact',
  addItem: 'Add contact',
  addItemA11y: 'Add contact',
  moveUpA11y: 'Move contact up',
  moveDownA11y: 'Move contact down',
  collapseA11y: 'Collapse contact details',
  expandA11y: 'Expand contact details',
  removeItemA11y: 'Remove contact',
};

export const MERCH_LABELS = {
  titlePlaceholder: 'Item or SKU',
  detailPlaceholder: 'Qty, price, size run, location…',
  secondFieldPlaceholder: 'Second value',
  untitledItem: 'Untitled item',
  itemFallback: 'Item',
  addItem: 'Add merch item',
  addItemA11y: 'Add merch item',
  moveUpA11y: 'Move item up',
  moveDownA11y: 'Move item down',
  collapseA11y: 'Collapse item details',
  expandA11y: 'Expand item details',
  removeItemA11y: 'Remove item',
};

export const STRUCTURED_DAY_LIST_TABS = new Set(['SETLIST', 'GUEST LIST', 'CONTACTS', 'MERCH']);

export const STRUCTURED_DAY_LIST_LABELS = {
  SETLIST: SETLIST_LABELS,
  'GUEST LIST': GUEST_LIST_LABELS,
  CONTACTS: CONTACTS_LABELS,
  MERCH: MERCH_LABELS,
};

export const STRUCTURED_DAY_LIST_MODAL_COPY = {
  SETLIST: {
    title: 'Setlist editor',
    hint: 'Add songs with optional detail lines — who plays what, notes, or anything else for each song.',
    savedOne: 'Saved setlist for this day.',
    savedMany: (n) => `Saved setlist to ${n} show days.`,
    saveError: 'Could not save setlist.',
  },
  'GUEST LIST': {
    title: 'Guest list editor',
    hint: 'Add guests with optional detail lines — plus-ones, roles, ticket notes, or anything else.',
    savedOne: 'Saved guest list for this day.',
    savedMany: (n) => `Saved guest list to ${n} show days.`,
    saveError: 'Could not save guest list.',
  },
  CONTACTS: {
    title: 'Contacts editor',
    hint: 'Add contacts with optional detail lines — phone, email, venue, role, or anything else.',
    savedOne: 'Saved contacts for this day.',
    savedMany: (n) => `Saved contacts to ${n} show days.`,
    saveError: 'Could not save contacts.',
  },
  MERCH: {
    title: 'Merch list editor',
    hint: 'Track what you are selling today — items, quantities, sizes, table notes, or anything else.',
    savedOne: 'Saved merch list for this day.',
    savedMany: (n) => `Saved merch list to ${n} show days.`,
    saveError: 'Could not save merch list.',
  },
};
